import {collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import db from "./Backend";
import { Button } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MonthList from "./newComponent/MonthList";
import Allreports from "./Allreportssub";
import Allchapterallocs from "./Allchapterallocs";
import AllUnitallocs from "./AllUnitsAllocs";
import Adminchapterunitview from "./newComponent/Adminchapterunitview";

const Adminreportdashb = () => {
    const [unitallocations,setUnitAlloccations]=useState([]);
    const [yearofentry,setEntryYear]=useState("");
    const [yearonfocus,setYearOnFocus]=useState("");

    const [allUnitreports,setAllreports]=useState([]);
    const [searchUnit,setUnitsearch]=useState("");
    const [specUnitform,setSpecUnitform]=useState("");
    const [searchChapterAlloc,setSearchChapAlloc]=useState("");
    const [searchUnitAlloc,setSearchUnitAlloc]=useState("");
    const [monthQuery,setMonthQuery]=useState("");
    const [dateQuery,setDateQuery]=useState("");
    const [filteredUnit,setFilteredunit]=useState([]);
    const [showfilteredunit,setShowFilterunit]=useState(false);
 
    const [chapterAllocs,setChapterAllocs]=useState([]);
    const [allLocations,setAllLocations]=useState(null);
    const [showAllLocations,setShowAlllocations]=useState(false);
    const [dropchapterList,setDropchapterlist]=useState(false);
    const [showListofMonths,setShowListMonths]=useState(false);


    // const now = Timestamp.now();
    // const dateSent = new Date(now?.toDate()).toUTCString();

    useEffect(()=>{
        const currentDate = new Date();
        setEntryYear(currentDate.getFullYear().toString());
        setYearOnFocus(currentDate.getFullYear().toString());
    },[]);

    const changeYearOnFocus=(yearvalue)=>{
        if(yearonfocus !== ""){
            setEntryYear(yearvalue);
        }
    };

    useEffect(()=>{
        const collectionRef = collection(db,"unitremittances");
        const q = query(collectionRef,where("year","==",yearofentry),orderBy("date_sent","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setUnitAlloccations(firedocs);
        })
        return unsub;
    },[yearofentry]);

    useEffect(()=>{
        const collectionRef = collection(db,"weeklyreport");
        const q = query(collectionRef,where("yearofentry","==",yearofentry),orderBy("dateofentry","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setAllreports(firedocs);
        })
        return unsub;
    },[yearofentry]);

    useEffect(()=>{
        const collectionRef = collection(db,"chapterremittances");
        const q = query(collectionRef,where("year","==",yearofentry),orderBy("date_sent","asc"));
        const unsub = onSnapshot(q, (snapshot)=>{
            const firedocs = [];
            snapshot.forEach((doc)=>{
                firedocs.push(doc.data());
            });
            setChapterAllocs(firedocs);
        });
        return unsub;
    },[yearofentry]);

    useEffect(()=>{
        const collectionRef = collection(db,"reports"); //collection of both chapter and units
        const unsub = onSnapshot(collectionRef, (snapshot)=>{
            const items = [];
            snapshot.forEach((doc)=>{
                items.push(doc.data());
            })
            setAllLocations(items);
        });
        return unsub;
    },[]);

    const Unitquery=(e)=>{
        e.preventDefault();
        if(allUnitreports.length > 0){
            if(monthQuery !== "" && searchUnit !== "" && dateQuery === ""){
                let result = allUnitreports.filter(chapter =>
                    chapter.chapter_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnit.toLowerCase())
                    && chapter.monthofentry.toLowerCase().includes(monthQuery.toLowerCase()));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit !== "" && monthQuery === "" && dateQuery === ""){
                let result = allUnitreports.filter(chapter =>
                    chapter.chapter_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnit.toLowerCase()));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit === "" && monthQuery !=="" && dateQuery === ""){
                let result = allUnitreports.filter(chapter =>
                    chapter.monthofentry.toLowerCase().includes(monthQuery.toLowerCase()));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit !== "" && dateQuery !== "" && monthQuery === ""){
                let result = allUnitreports.filter(chapter =>
                    chapter.chapter_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnit.toLowerCase())
                    && chapter.dateofentry.replace(/[^\w\s]|_/g, '').toLowerCase().includes(dateQuery.toLowerCase().replace(/[^\w\s]|_/g, '')));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }else if(searchUnit === "" && monthQuery === "" && dateQuery !== ""){
                let result = allUnitreports.filter(chapter =>
                    chapter.dateofentry.replace(/[^\w\s]|_/g, '').toLowerCase().includes(dateQuery.toLowerCase().replace(/[^\w\s]|_/g, '')));
                  if(result.length > 0){
                    setFilteredunit(result);
                    setShowFilterunit(true);
                  }
            }
        }
    };

    const resetQueryfield=()=>{
        setFilteredunit([]);
        setShowFilterunit(false);
        setUnitsearch("");
        setMonthQuery("");
        setDateQuery("");
    };

    const handleUnitquery=(unitname)=>{
        setSpecUnitform(unitname);
        setSearchUnitAlloc(unitname);
        setShowAlllocations(false);
    };
    const handleChapterquery=(chaptername)=>{
        setUnitsearch(chaptername);
        setSearchChapAlloc(chaptername);
        setShowAlllocations(false);
        setDropchapterlist(false);
    };
    const handleInsertMonth=(month)=>{
        setMonthQuery(month);
        setShowListMonths(false);
    };


    return ( 
        <div className="adminreportdashb">
            <div className="topchapterdashb flex-spacebetween">
                <form onSubmit={Unitquery}>
                <fieldset>
                    <legend>General query</legend>
                    <div className="flex-row3">
                        
                    <div className="flex-row2" style={{position:"relative"}}>
                    <input type="search" placeholder="enter chapter name" value={searchUnit} onChange={e => setUnitsearch(e.target.value)}/>
                    <button onClick={()=>setDropchapterlist(prev => !prev)}>
                        <ArrowDropDownIcon/>
                    </button>
                    {dropchapterList && 
                        <div className="dropchapterlist flex-column1">
                            {allLocations && allLocations.map(data => (
                                <Adminchapterunitview
                                key={data.chapterName}
                                chapteronly={data.chapterName}
                                handlechapter={handleChapterquery}
                                />
                            ))}
                        </div>
                    }
                    </div>
                   
                    <div className="flex-row2" style={{position:"relative"}}>
                    <input type="search" placeholder="month" value={monthQuery} onChange={e => setMonthQuery(e.target.value)}/>
                    <button onClick={()=>setShowListMonths(prev => !prev)}>
                        <ArrowDropDownIcon/>
                    </button>
                    {showListofMonths &&
                        <div className="listofmonths">
                            <MonthList selectedmonth={handleInsertMonth} />
                        </div>
                    }
                    </div>
                   
                    <input type="date" placeholder="date" value={dateQuery} onChange={e => setDateQuery(e.target.value)}/>
                    <button>query</button>
                    {showfilteredunit && <Button onClick={resetQueryfield}>Reset</Button>}
                    </div>
                </fieldset>
                </form>
                <div className="chapterdashbunitnames flex-row2">
                    <h3>All Locations</h3>
                    <svg
                    onClick={()=>setShowAlllocations(prev => !prev)}
                    cursor="pointer"
                    viewBox="0 0 24 24"
                    fill="#000000"
                    height="1.5em"
                    width="1.5em">
                    <path fill="none" d="M0 0h24v24H0V0z" />
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
                    </svg>

                    {showAllLocations && 
                        <div className="droplocations flex-row2">
                             {allLocations && allLocations.map(data => (
                                <Adminchapterunitview
                                key={data.chapterName}
                                chapterName={data.chapterName}
                                unit1={data.unit1}
                                unit2={data.unit2}
                                unit3={data.unit3}
                                unit4={data.unit4}
                                unit5={data.unit5}
                                unit6={data.unit6}
                                unit7={data.unit7}
                                unit8={data.unit8}
                                unit9={data.unit9}
                                unit10={data.unit10}
                                handlechapter={handleChapterquery}
                                handleunit={handleUnitquery}
                                />
                            ))}
                        </div>
                    }
                </div>
      
                <fieldset>
                    <legend>Year on Focus</legend>
                    <div className="flex-row2">
                    <input type="search" value={yearonfocus} required onChange={e => setYearOnFocus(e.target.value)}/>
                    <button onClick={()=>changeYearOnFocus(yearonfocus)}>Change</button>
                    </div>
                </fieldset>
            </div>

            <div className="chapterdashbody">
                 <div className="leftchapterdashbar">
                    <div className="leftchapterdashbcontent">
                        <fieldset>
                            <legend>Chapter Account</legend>
                            <input type="search" placeholder="enter chapter name" value={searchChapterAlloc} onChange={e => setSearchChapAlloc(e.target.value)}/>
                        </fieldset>
                            {chapterAllocs && chapterAllocs.filter((data)=>{
                                if(searchChapterAlloc === ""){
                                    return true;
                                }else if(data.chapter_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchChapterAlloc.toLowerCase().replace(/[^\w\s]|_/g, ''))){
                                    return true;
                                }
                                return false;
                            }).map(data =>(
                                <Allchapterallocs
                                key={data.date_sent}
                                chapter_name={data.chapter_name}
                                month_on_focus={data.month_on_focus}
                                amount_alloted={data.amount_alloted}
                                total_month_income={data.total_month_income}
                                date_sent={data.date_sent}
                                username={data.username}
                                />
                            ))}
                    </div>
                </div>

                <div className="middledashbar">
                    <h2>{!showfilteredunit ? `All Reports` : searchUnit !== "" && monthQuery === "" ? `Report for: ${searchUnit}`
                        : monthQuery !== "" && searchUnit === "" ? `Reports on ${monthQuery}` 
                        : searchUnit !== "" && monthQuery !== "" ? `Report for: ${searchUnit} on ${monthQuery}`
                        : `Reports on ${dateQuery}` }
                        
                    </h2>
                    <fieldset>
                        <legend>Unit Query</legend>
                        <input type="search" placeholder="unit name" value={specUnitform} onChange={e => setSpecUnitform(e.target.value)}/>
                    </fieldset>

                        {!showfilteredunit && 
                        <div className="middledashbarcontent flex-row2">
                            {allUnitreports && allUnitreports.filter((data)=>{
                                if(specUnitform === ""){
                                    return true;
                                }else if(data.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(specUnitform.toLowerCase().replace(/[^\w\s]|_/g, ''))){
                                    return true;
                                }
                                return false;

                            }).map(data =>(
                                <Allreports
                                key={`${data.dateofentry+data.unit_name}`}
                                unit_name={data.unit_name}
                                chapter_name={data.chapter_name}
                                username={data.username}
                                dateofentry={data.dateofentry}
                                monthofentry={data.monthofentry}
                                yearofentry={data.yearofentry}
                                message={data.message}
                                men = {data.men}
                                women={data.women}
                                youth={data.youth}
                                children={data.children}
                                total_attend={data.total_attend}
                                tithe={data.tithe}
                                offering={data.offering}
                                total={data.total}
                                menAttend={data.menAttend}
                                womenAttend={data.womenAttend}
                                youthAttend={data.youthAttend}
                                childAttend={data.childAttend}
                                expenditure={data.expenditure}
                                expensedetails={data.expensedetails}
                                remainingIncome={data.remainingIncome}
                                remarks={data.remarks}
                                modifieddate={data.modifieddate}
                              
                                />
                            ))}
                        
                        </div>
                        }
                        
                        {showfilteredunit && 
                            <div className="middledashbarcontent flex-row2">
                            {filteredUnit && filteredUnit.filter((data)=>{
                                if(specUnitform === ""){
                                    return true;
                                }else if(data.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(specUnitform.toLowerCase().replace(/[^\w\s]|_/g, ''))){
                                    return true;
                                }
                                return false;
                            }).map(data =>(
                                <Allreports
                                key={`${data.dateofentry+data.unit_name}`}
                                unit_name={data.unit_name}
                                chapter_name={data.chapter_name}
                                username={data.username}
                                dateofentry={data.dateofentry}
                                monthofentry={data.monthofentry}
                                yearofentry={data.yearofentry}
                                message={data.message}
                                men = {data.men}
                                women={data.women}
                                youth={data.youth}
                                children={data.children}
                                total_attend={data.total_attend}
                                tithe={data.tithe}
                                offering={data.offering}
                                total={data.total}
                                menAttend={data.menAttend}
                                womenAttend={data.womenAttend}
                                youthAttend={data.youthAttend}
                                childAttend={data.childAttend}
                                expenditure={data.expenditure}
                                expensedetails={data.expensedetails}
                                remainingIncome={data.remainingIncome}
                                />
                            ))}
                            </div>
                        }
                </div>

                <div className="rightchapterdashbar">
                    <fieldset>
                        <legend>Unit Account</legend>
                        <input type="search" placeholder="unit name" value={searchUnitAlloc} onChange={e => setSearchUnitAlloc(e.target.value)}/>
                    </fieldset>
                        <div className="rightchapterdashbcontent flex-column1">
                            {unitallocations && unitallocations.filter((data)=>{
                                if(data.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes("chapter")){
                                    return false;
                                }else if(searchUnitAlloc === "" ||
                                    data.unit_name.replace(/[^\w\s]|_/g, '').toLowerCase().includes(searchUnitAlloc.toLowerCase().replace(/[^\w\s]|_/g, ''))){
                                    return true;
                                }
                                return false;

                            }).map(data =>(
                                <AllUnitallocs
                                key={data.date_sent}
                                unit_name={data.unit_name}
                                month_on_focus={data.month_on_focus}
                                amount_alloted={data.amount_alloted}
                                total_month_income={data.total_month_income}
                                date_sent={data.date_sent}
                                username={data.username}
                                />
                            ))}
                        </div>
            
                </div>
            </div>
        </div>
     );
}
export default Adminreportdashb;